import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon'
import { mdiLogin } from '@mdi/js'
import { FunctionComponent } from 'react'

export const IconLogin: FunctionComponent<SvgIconProps> = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path d={mdiLogin} />
	</SvgIcon>
)
